export { default } from '@speedwaymotors/clutch/Layout/Next/_app'
